import gql from 'graphql-tag';

/**
 * "Job" backend entity
 *
 * @typedef Job
 * @type {object}
 * @property {string} id - ID of the resource file
 * @property {string} status - job status
 * @property {object[]} processingErrors - job processing errors
 */

export const FRAGMENT_JOB = gql`
  fragment Job on Job {
    id
    status
    result
    processingErrors {
      code
      errorProperties
      message
    }
  }
`;
